import React from "react";

const ProcessingStep = ({ title, description }) => {
  return (
    <div className="w-full max-w-4xl bg-white rounded-lg shadow-sm p-6 mb-6 flex flex-col items-center justify-center">
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-l-4 border-emerald-600 mb-6"></div>
      <h2 className="text-xl font-medium text-gray-800 mb-2">
        {title}
      </h2>
      <p className="text-gray-600">
        {description}
      </p>
    </div>
  );
};

export default ProcessingStep;
